<template lang="html">
  <div class="order-details">
    <div class="has-text-centered">
      <span
        v-if="orderInfo === null && loading > 0"
        class="icon has-text-primary is-large"
      >
        <i class="las la-2x la-arrow-down" aria-hidden="true"></i>
      </span>
    </div>
    <div class="hero has-text-centered is-small is-bottom-marginless">
      <div class="hero-body has-text-primary">
        <icon :name="tripTypeIcon" scale="5" :label="tripTypeIcon"></icon>

        <div class="is-size-4">
          {{
            (orderInfo &&
              orderInfo.dispatchPull &&
              orderInfo.dispatchPull.tripType) ||
              (orderInfo && orderInfo.tripType) ||
              ''
          }}
        </div>
      </div>
    </div>
    <cw-box-info
      v-if="orderInfo !== null"
      :boxSetInfo="orderInfo"
      :displayOrderInfo="true"
    />
    <div
      v-if="
        orderInfo !== null && orderInfo.status && orderInfo.status === 'POHold'
      "
      class="has-text-centered is-padded-medium"
    >
      <a
        class="button is-warning is-rounded is-medium"
        name="button"
        @click="showPOWarning"
      >
        <span class="icon">
          <i class="las la-2x la-exclamation-circle"></i>
        </span>
        <span>PO Needed</span>
      </a>
    </div>
  </div>
</template>

<script>
import { DISPATCH_SET_DETAILS_QUERY } from '@/graphql/constants';

export default {
  name: 'order-details',
  // share common functionality with component mixins
  mixins: [],
  props: {},
  // variables
  data() {
    return {
      loading: 0,
      orderInfo: null,
    };
  },
  apollo: {
    orderInfo: {
      query: DISPATCH_SET_DETAILS_QUERY,
      variables() {
        return { workOrderId: this.$route.params.id };
      },
      update(data) {
        // The returned value will update
        // the vue property 'orderInfo'
        return data.dispatchSet;
      },
    },
  },
  computed: {
    tripTypeIcon() {
      let orderInfo = this.orderInfo;
      if (orderInfo) {
        let icon = orderInfo.tripType && orderInfo.tripType.toLowerCase();
        icon =
          (orderInfo.dispatchPull &&
            orderInfo.dispatchPull.tripType &&
            orderInfo.dispatchPull.tripType.toLowerCase()) ||
          icon;

        return icon;
      }
      return 'set';
    },
  },
  components: {},
  // methods
  watch: {},
  methods: {
    showPOWarning() {
      // see duplicate warning in DetailsOrder
      this.$modal.show('alert', {
        title: 'PO Needed',
        subtitle: 'Contact Dispatch',
        message:
          'A purchase order number is required before this order can be fulfilled. Contact dispatch to specify the PO.',
        type: 'warning',
      });
    },
  },
  mounted() {
    this.$apollo.queries.orderInfo.refetch();
  },
};
</script>

<style lang="stylus" scoped></style>
